export const wellness_health = [
  { char: '🧘', name: 'Yoga', nameZh: '身心靈平衡', keywords: ['zen', 'yoga', 'meditate'], hot: true },
  { char: '🛀', name: 'Bath', nameZh: '泡澡放鬆', keywords: ['relax', 'spa', 'clean'] },
  { char: '🥗', name: 'Salad', nameZh: '健康飲食', keywords: ['healthy', 'diet', 'green'], hot: true },
  { char: '💊', name: 'Pill', nameZh: '保健食品', keywords: ['vitamin', 'health', 'medicine'] },
  { char: '🧠', name: 'Brain', nameZh: '心理健康', keywords: ['mental', 'think', 'smart'] },
  { char: '🍵', name: 'Matcha', nameZh: '茶道/靜心', keywords: ['tea', 'japan', 'relax'] },
  { char: '🍎', name: 'Apple', nameZh: '每日營養', keywords: ['fruit', 'doctor', 'health'] },
  { char: '🤸', name: 'Cartwheel', nameZh: '運動拉筋', keywords: ['gymnastic', 'active', 'stretch'] },
  { char: '🩹', name: 'Bandage', nameZh: '療癒受傷', keywords: ['heal', 'hurt', 'care'] },
  { char: '🛌', name: 'In Bed', nameZh: '充足睡眠', keywords: ['sleep', 'rest', 'bed'] },
  { char: '🧿', name: 'Nazar', nameZh: '能量守護', keywords: ['protect', 'luck', 'energy'] },
  { char: '🫧', name: 'Bubbles', nameZh: '呼吸空間', keywords: ['dream', 'clean', 'air'] },
];